// extracted by mini-css-extract-plugin
module.exports =  {"bannersnack":"iNAnLIH6BEMo35ugad_d","creativeButton":"pL0k4b78O_by8HIGFDRA","specTable":"xKAumkeW2ZaOnjpnZHot"};